import React, { useState } from 'react';
import { Box, Button, Chip, Dialog, DialogActions, DialogContent, DialogTitle, Divider, Grid, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import { useDispatch, useSelector } from "react-redux";
import { getFoodPartnersForReservationState } from "../../../../../features/food_partner/get_food_partners_for_reservation";
import { generateReservationDocumentsNotificationData } from "../../../../../core/utils/notification_utils";
import { generateReservationDocumentsAction } from "../../../../../features/reservation/generate_reservation_documents";
import { ApiRequestStatusEnum } from "../../../../../core/enums/common/api";
import { AutocompleteFormik } from "../../../../common/autocomplete";
import { SubmitButton } from "../../../../common/button";
import useNotification from "../../../../../core/hooks/use_notification";
import * as Yup from 'yup';
import { Form, Formik } from 'formik';

const GenerateReservationDocumentsDialog = ({ open, date, onClose }) => {
    const dispatch = useDispatch();
    const { showErrorMessage } = useNotification();
    const getFoodPartnersForReservation = useSelector(getFoodPartnersForReservationState);

    const [result, setResult] = useState(null);
    const [loading, setLoading] = useState(false);

    const schema = Yup.object().shape({
        foodPartner: Yup.object().required("Wybierz dostawcę"),
    });

    const handleSubmit = (values) => {
        setLoading(true);
        dispatch(generateReservationDocumentsAction({
            forDate: date,
            foodPartnerId: values.foodPartner.value
        })).then(response => {
            showErrorMessage(generateReservationDocumentsNotificationData(response));
            if (response?.meta?.requestStatus === ApiRequestStatusEnum.FULFILLED) {
                setResult(response?.payload || null);
            }
            setLoading(false);
        });
    };

    const handleClose = () => {
        setResult(null);
        onClose();
    };

    return (
        <Dialog open={ open } onClose={ handleClose } maxWidth="md" fullWidth>
            <DialogTitle sx={ { fontWeight: 600, pb: 1 } }>
                { !result ? "Wybierz dostawcę" : "Wyniki generowania dokumentów" }
            </DialogTitle>
            <Divider/>

            <DialogContent sx={ { py: 3 } }>
                { !result ? (
                    <Formik
                        initialValues={ { foodPartner: '' } }
                        validationSchema={ schema }
                        validateOnChange={ false }
                        validateOnBlur={ false }
                        onSubmit={ handleSubmit }
                    >
                        { () => (
                            <Form>
                                <Grid container spacing={ 3 }>
                                    <Grid item xs={ 12 }>
                                        <AutocompleteFormik
                                            name="foodPartner"
                                            label="Dostawca"
                                            options={
                                                getFoodPartnersForReservation?.data?.map(fp => ({
                                                    key: fp.id,
                                                    value: fp.id,
                                                    label: fp.name
                                                })) || []
                                            }
                                            required
                                        />
                                    </Grid>
                                </Grid>

                                <Divider sx={ { mt: 3, mb: 2, mx: -3 } }/>

                                <DialogActions sx={ { p: 0, gap: 1 } }>
                                    <Button variant="outlined" onClick={ handleClose }>Anuluj</Button>
                                    <SubmitButton isLoading={ loading }>Generuj</SubmitButton>
                                </DialogActions>
                            </Form>
                        ) }
                    </Formik>
                ) : (
                    <Box>
                        <TableContainer component={ Paper } variant="outlined">
                            <Table size="small">
                                <TableHead>
                                    <TableRow sx={ { '& th': { backgroundColor: 'slate.50', fontWeight: 600 } } }>
                                        <TableCell>Status</TableCell>
                                        <TableCell>Rodzaj operacji</TableCell>
                                        <TableCell>Wygenerowano</TableCell>
                                        <TableCell>Uwagi</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    <TableRow hover>
                                        <TableCell>
                                            { result.success ? (
                                                <Chip label="Sukces" color="success" size="small"/>
                                            ) : (
                                                <Chip label="Błąd" color="error" size="small"/>
                                            ) }
                                        </TableCell>
                                        <TableCell>
                                            { result.useExistingResources === true && "Przesuń istniejące zasoby" }
                                            { result.useExistingResources === false && "Zamów nowe sztuki" }
                                            { result.useExistingResources == null && "Nieokreślony" }
                                        </TableCell>
                                        <TableCell>
                                            { result.useExistingResources === true && result.generatedDocuments?.map(d => (
                                                <div key={ d }>{ d }</div>
                                            )) }
                                            { result.useExistingResources === false && result.generatedFoodPartnerOrder && (
                                                <div>
                                                    Zamówienie #{ result.generatedFoodPartnerOrder }
                                                </div>
                                            ) }
                                        </TableCell>
                                        <TableCell>{ result.error || '-' }</TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </TableContainer>

                        <Divider sx={ { mt: 3, mb: 2, mx: -3 } }/>

                        <DialogActions sx={ { p: 0, gap: 1 } }>
                            <Button onClick={ handleClose }>Zamknij</Button>
                        </DialogActions>
                    </Box>
                ) }
            </DialogContent>
        </Dialog>
    );
};

export default GenerateReservationDocumentsDialog;